import { Page } from '@roc/feature-app-core';
import { Route } from 'react-router';
import { DebtTrackingDashboard } from '../components/debtTracking/debtTrackingDashboard';


export const getDebtTrackingRoutesConfig = (
  basePath: string,
  baseUrl: string,
) => {
  return {
    debtTrackingDashboard: {
      path: `${basePath}/trades/debt-tracking`,
      url: `${baseUrl}/trades/debt-tracking`,
      documentTitle: 'Debt Tracking',
    },
  };
};

export const getDebtTrackingRoutes = (basePath: string, baseUrl: string) => {
  const config = getDebtTrackingRoutesConfig(basePath, baseUrl);

  return {
    debtTrackingDashboard: (
      <Route exact path={config.debtTrackingDashboard.path}>
        <Page routeDefinition={config.debtTrackingDashboard}>
          <DebtTrackingDashboard />
        </Page>
      </Route>
    ),
  };
};
